module.exports = __webpack_public_path__ + "static/media/login-comercial.33bec9ad.jpg";